import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { useLanguage } from '../../context/LanguageContext';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <h1 style={{ display: 'flex', alignItems: 'center', fontSize: '1.5rem', fontWeight: 'bold', textTransform: 'uppercase' }}>
          <span style={{ color: 'var(--black-color)' }}>CYR</span>
          <span style={{ color: 'var(--secondary-color)', marginLeft: '2px' }}>TEDDY</span>
        </h1>
      </div>
      <ul className="app__navbar-links">
        {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{t.navbar[item]}</a>
          </li>
        ))}
      </ul>

      <div className="language-toggle">
        <button
          type="button"
          onClick={toggleLanguage}
          style={{
            background: 'transparent',
            border: '1px solid var(--secondary-color)',
            borderRadius: '20px',
            padding: '0.3rem 0.8rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            color: 'var(--secondary-color)',
            marginLeft: '1rem',
          }}
        >
          {language.toUpperCase()}
        </button>
      </div>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
